import { createApiHooks } from '@apis/next/common';
import { Commodity } from '@models/next/Commodity';
import {
  PostPreviewArrivalNotice,
  PostPreviewCustomsRequest,
  PostPreviewDeliveryRequest,
  PostPreviewInvoice,
  PostPreviewPaymentSlip,
  PostPreviewClientPriceSimulator,
} from '@models/next/Pdf';
import { f } from '@utils/nextForms';
import { z } from 'zod';

export const pdfApis = createApiHooks('/pdf', [
  {
    method: 'get',
    path: '/:secure_data_key',
    parameters: [
      {
        type: 'Path',
        name: 'secure_data_key',
        schema: z.string(),
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'get',
    path: '/ArrivalNotice/:d2d_no',
    parameters: [
      {
        type: 'Path',
        name: 'd2d_no',
        schema: z.string(),
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'get',
    path: '/BookingInquiryDisplay/:d2d_no',
    parameters: [
      {
        type: 'Path',
        name: 'd2d_no',
        schema: z.string(),
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'get',
    path: '/BookingInquiryPriceSettlement/:d2d_no',
    parameters: [
      {
        type: 'Path',
        name: 'd2d_no',
        schema: z.string(),
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'get',
    path: '/SeaWaybill/:d2d_no',
    parameters: [
      {
        type: 'Path',
        name: 'd2d_no',
        schema: z.string(),
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'post',
    path: '/preview/ClientPriceSimulator',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PostPreviewClientPriceSimulator,
      },
    ],
    response: f.instanceOfBlob(),
  },
]);

export const dashboardPdfApis = createApiHooks('/dashboard/pdf', [
  {
    method: 'post',
    path: '/preview/CustomsCommodity',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: Commodity.array(),
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'post',
    path: '/preview/ArrivalNotice',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PostPreviewArrivalNotice,
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'post',
    path: '/preview/CustomsRequest',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PostPreviewCustomsRequest,
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'post',
    path: '/preview/DeliveryRequest',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PostPreviewDeliveryRequest,
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'post',
    path: '/preview/PaymentSlip',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PostPreviewPaymentSlip,
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'post',
    path: '/preview/Invoice',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PostPreviewInvoice,
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'get',
    path: '/CustomsCommodity/:d2d_no',
    parameters: [
      {
        type: 'Path',
        name: 'd2d_no',
        schema: z.string(),
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'get',
    path: '/SeaWaybill/:d2d_no',
    parameters: [
      {
        type: 'Path',
        name: 'd2d_no',
        schema: z.string(),
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'get',
    path: '/ArrivalNotice/:d2d_no',
    parameters: [
      {
        type: 'Path',
        name: 'd2d_no',
        schema: z.string(),
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'get',
    path: '/CustomsRequest/:d2d_no',
    parameters: [
      {
        type: 'Path',
        name: 'd2d_no',
        schema: z.string(),
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'get',
    path: '/DeliveryRequest/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'get',
    path: '/PaymentSlip/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
    ],
    response: f.instanceOfBlob(),
  },
]);
